var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "CVS Health Heart"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.701 0a4.513 4.513 0 0 0-3.134 1.247l-6.272 6.01a4.126 4.126 0 0 0 .007 6.01l17.701 16.96 17.7-16.96a4.127 4.127 0 0 0-.003-6.01L30.432 1.25A4.5 4.5 0 0 0 27.3 0a4.52 4.52 0 0 0-3.144 1.255l-5.154 4.939-5.16-4.945A4.521 4.521 0 0 0 10.7 0Z",
    fill: "#C00"
  })));
};
export default SvgHeart;